import { call, put, select } from "redux-saga/effects";
import { notify } from "../../../services/notification";
import api, { makeOptions } from "../../../services/api";
import ActionsDeleteInvoice from "../../ducks/branch-invoices/delete-invoice";

const getAuthData = (state) => state.auth.data;

export function* destroy(action) {
  try {
    const { params, onSuccess } = action;

    const url = `branch-invoice/${params}`;
    const authData = yield select(getAuthData);
    const { data } = yield call(api.delete, url, makeOptions(authData));

    yield put(ActionsDeleteInvoice.success(data.data));
    notify("success", "NF reprovada com sucesso!");
    onSuccess();
  } catch (err) {
    notify("error", err.response.data.error.message);
    yield put(ActionsDeleteInvoice.failure(err.response.data.error.message));
  }
}
